export default "__VITE_ASSET__BZd8Q98w__"